import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "primereact/resources/primereact.min.css";
import "primeflex/primeflex.min.css";
import "primeicons/primeicons.css";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/themes/viva-dark/theme.css";
import "./App.css";

import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { getAuthConfigForEnvironment } from "./config/environmentConfig";
import { Environment } from "./types/MainContextType";
import "@aws-amplify/ui-react/styles.css";

// Get the initial environment from localStorage or default to production
const storedEnvironment = localStorage.getItem('idwal-environment') || 'production';
const initialAuthConfig = getAuthConfigForEnvironment(storedEnvironment as Environment);

// Configure Amplify with the initial environment's auth config
Amplify.configure(initialAuthConfig);

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
